<!-- <section class="main-bg">
  <lib-login-form [content]="userInfo"></lib-login-form>
</section> -->

<!-- New  -->
<section class="ntt-login">
  <h1 id="titleLogin" class="title-login"></h1>
  <lib-login-form [content]="userInfo"></lib-login-form>
</section>
